
import store from '@/store';
import { numberToWords } from '@persian-tools/persian-tools';
import { defineComponent } from 'vue';
import ButtonComponent from '@/components/appComponents/Button.vue';

export default defineComponent({
    name: "AccountChargeBoxComponent",

    props: ["user"],

    components: { ButtonComponent },

    data() {
        return {
            selectedBox: "charge",
            amount: "",
            toman: 0,
            tomanText: "",
            description: "",
            boxes: [
                {
                    title: "افزایش",
                    value: "charge"
                },
                {
                    title: "کاهش",
                    value: "decharge"
                }
            ]
        }
    },

    computed: {
        getLoadingPanel(): boolean {
            return store.getters["panel/getLoadingPanel"];
        },
    },

    methods: {
        formatNumber() {
            this.amount = this.amount.replace(/[^0-9]/g, ''); // Remove non-numeric chars
            // convert amount to text
            const rialValue = parseFloat(this.amount) || 0; // Handle invalid input
            this.toman = rialValue; // 1 Toman = 10 Rial

            // Format Toman amount in Persian with words
            this.tomanText = this.formatTomanWithWords(this.toman);
        },

        formatTomanWithWords(tomanAmount: number) {
            const tomanInteger = Math.floor(tomanAmount);
            const tomanDecimal = (tomanAmount * 10) % 10; // Get the decimal part (one digit)

            let tomanWord = numberToWords(tomanInteger);

            if (tomanDecimal > 0) {
                tomanWord += ` و ${numberToWords(tomanDecimal)} دهم`; // Add decimal part if any.
            }

            return tomanWord + " تومان";
        },

        FormatPersianAmount(amount: number | string): string {
            // Convert to number if it's a string
            const num = typeof amount === 'string' ? parseFloat(amount) : amount;

            if (isNaN(num)) {
                return "مبلغ نا معتبر"; // Or handle the error as you prefer
            }

            const parts = num.toString().split(".");
            const integerPart = parts[0];
            const fractionalPart = parts[1] || '';

            // Apply thousands separator to the integer part
            const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            // Combine integer and fractional parts
            const formattedAmount = fractionalPart ? `${formattedIntegerPart}.${fractionalPart}` : formattedIntegerPart;

            return formattedAmount;
        },

        handleBox(box: { title: string, value: string }) {
            this.selectedBox = box.value;
            this.$emit("search", { status: this.selectedBox, query: '' });
        },

        activeChargeBox() {
            const status = this.selectedBox;
            switch (status) {
                case 'charge':
                    return 'bg-gray-200 text-white';
                case 'decharge':
                    return 'bg-error-500 text-white';

                default:
                    return 'bg-white'
            }
        },

        chargeType() {
            switch (this.selectedBox) {
                case 'charge':
                    return '1';

                case 'decharge':
                    return '2';

                default:
                    break;
            }
        },

        submitChargeAccount(): void {
            const chargeData = {
                userId: this.user.id,
                type: this.chargeType(),
                amount: this.amount,
                description: this.description
            };

            this.$emit("charge-account", chargeData);
        },

        submitUserCashout(): void {
            const data = {
                userId: this.user?._id,
            };

            this.$emit("user-cashout", data);
        }
    },
})
